var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Sliders',{attrs:{"data":_vm.slidersFinance,"loading":_vm.app.isFinanceLoading},on:{"update":_vm.handleSliderUpdate}}),_c('RateDisclaimer',{staticClass:"mt-12"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }